import { Injectable } from "@angular/core"
import { ApiService } from './api.service'
import { UserService } from './user.service'
import { BudgetDiscipline } from './budget-discipline.model'
import { CalendarScope } from './calendar-scope.model';
import { Credit } from './credit.model'
import { Region } from "./region.model"
import { Tag } from "./tag.model"
import { Status } from './status.model'
import { Structure } from "./structure.model"
import { Taxonomy } from "./taxonomy.model"
import { DeliveryMethod } from './delivery-method.model';

@Injectable({
    providedIn: 'root',
})
export class CacheService {
    userUpdateAlert;
    data = [];
    dataComplete = 0;
    dataCalls;
    isLoading: boolean = true;
    attempt = 0;
    budgetDisciplines: BudgetDiscipline[];
    calendarScopes: CalendarScope[];
    credits: Credit[];
    regions: Region[];
    tagsStatewide: Tag[];
    regionsScoped: Region[];
    structures: Structure[];
    statuses: Status[];
    courseTaxonomy: Taxonomy[];
    deliveryMethods: DeliveryMethod[];
    // statusRegistration

    yesNo = [
        { name: "Yes", value: true },
        { name: "No", value: false },
    ];

    active = [
        { name: "Active", value: "Active" },
        { name: "Inactive", value: "Inactive" },
    ];

    calendarReminder = [
        { name: "Event Start/End Date", value: "event"},
        // { name: "Session Attendance(s) Start/End Date", value: "session"},
    ];
    constructor(
        private apiService: ApiService,
        private userService: UserService
    ) {
        this.userUpdateAlert = userService.userUpdate$.subscribe(() => {
            this.getData();
        });

        if( this.userService.isAuthorized ){
            this.getData();
        }
    }

    getData() {
        this.data = [
            this.getBudgetDiscipline(),
            this.getCalendarScopes(),
            this.getCredits(),
            this.getRegions(),
            this.getTagsStatewide(),
            this.getStructures(),
            this.getStatus(),
            this.getCourseTaxonomy(),
            this.getDeliveryMethods(),
            // this.getRegistrationStatus(),
        ];

        // need a valid Promise all or forkJoin to resolve isLoading to false
        // Promise.all(this.data).then((values) => {
        //   console.log("values", values)
        //   console.log("credits", this.credits)
        //   console.log("regions", this.regions)
        //   console.log("structures", this.structures)
        // this.isLoading = false
        // })
    }

    complete() {
        if (this.dataComplete !== this.data.length) return;
        
        // console.log(`cache data load complete`);
        this.isLoading = false;
    }

    getBudgetDiscipline() {
        this.apiService.getBudgetDiscipline().subscribe(
            (data) => {
                this.budgetDisciplines = data.map((budgetDiscipline) => {
                    return new BudgetDiscipline(budgetDiscipline);
                });
                this.dataComplete += 1;
                this.complete();
            },
            (error) => {
                console.error(error);
            }
        );
    }

    getCalendarScopes() {
        this.apiService.getCalendarScopes().subscribe(
            (data) => {
                this.calendarScopes = data.map((calendarScope) => {
                    return new CalendarScope(calendarScope);
                });
                this.dataComplete += 1;
                this.complete();
            },
            (error) => {
                console.error(error);
            }
        );
    }

    getCredits() {
        this.apiService.getCredits().subscribe(
            (data) => {
                this.credits = data.map((credit) => {
                    return new Credit(credit);
                });
                this.dataComplete += 1;
                this.complete();
            },
            (error) => {
                console.error(error);
            }
        );
    }

    getRegions() {
        this.apiService.getRegions().subscribe(
            (data) => {
                this.regionsScoped = data
                    .filter((region) => {
                        return this.userService.scopedRegions.includes(
                            parseInt(region.region_id)
                        );
                    })
                    .map((region) => {
                        return new Region(region);
                    });
                
                this.regions = data
                    .map((region) => {
                        return new Region(region);
                    });

                this.dataComplete += 1;
                this.complete();
            },
            (error) => {
                console.log(error);
            }
        );
    }

    getTagsStatewide() {
        this.apiService.getTagsStatewide().subscribe(
            (data) => {
                this.tagsStatewide = data.map((tag) => {
                    return new Tag(tag);
                });
                this.dataComplete += 1;
                this.complete();
            },
            (error) => {
                console.error(error);
            }
        );
    }

    getStatus() {
        this.apiService.getStatus().subscribe(
            (data) => {
                this.statuses = data.map((status) => {
                    return new Status(status);
                });
                this.dataComplete += 1;
                this.complete();
            },
            (error) => {
                console.error(error);
            }
        );
    }

    getStructures() {
        this.apiService.getStructures().subscribe(
            (data) => {
                this.structures = data.map((structure) => {
                    return new Structure(structure);
                });
                this.dataComplete += 1;
                this.complete();
            },
            (error) => {
                console.error(error);
            }
        );
    }

    getCourseTaxonomy() {
        this.apiService.getTaxonomy('course').subscribe(
            (data) => {
                this.courseTaxonomy = data.map((taxonomy) => {
                    return new Taxonomy(taxonomy);
                });
                this.dataComplete += 1;
                this.complete();
            },
            (error) => {
                console.error(error);
            }
        );
    }

    getDeliveryMethods() {
        this.apiService.getDeliveryMethods().subscribe(
            (data) => {
                this.deliveryMethods = data.map((deliveryMethod) => {
                    return new DeliveryMethod(deliveryMethod);
                });
                this.dataComplete += 1;
                this.complete();
            },
            (error) => {
                console.error(error);
            }
        );
    }

    // getRegistrationStatus(): void {
    //   this.apiService.getRegistrationStatus().subscribe(
    //     (data) => {
    //       this.statusRegistration = data
    //       // t[his.status.push({status_id: 100, name: "No Session Attendance"})
    //       // t]his.status.push({status_id: 101, name: "No Credits"})
    //     },
    //     (error) => {
    //       console.error(error)
    //     }
    //   )
    // }
}
